import { render } from "./NotificationHighCharts.vue?vue&type=template&id=533ec774&scoped=true&ts=true"
import script from "./NotificationHighCharts.vue?vue&type=script&lang=ts"
export * from "./NotificationHighCharts.vue?vue&type=script&lang=ts"

import "./NotificationHighCharts.vue?vue&type=style&index=0&id=533ec774&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533ec774"]])

export default __exports__